var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      {
        staticStyle: {
          height: "100%",
          display: "flex",
          "flex-direction": "column"
        }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "flex-end",
              "margin-bottom": "5px"
            }
          },
          [
            _c(
              "el-button",
              {
                attrs: { no: "7", type: "primary" },
                on: { click: _vm.voyageCostAdd }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
            ),
            _c(
              "el-button",
              {
                attrs: { no: "8", type: "danger" },
                on: { click: _vm.voyageCostDel }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
            )
          ],
          1
        ),
        _c(
          "cargo-left-right-resize",
          {
            staticStyle: { "min-height": "80%" },
            attrs: {
              "left-style": { width: "30%" },
              "right-style": { width: "70%" }
            }
          },
          [
            _c(
              "template",
              { slot: "left" },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { height: "100%" },
                  attrs: {
                    no: "6",
                    "config-module": "150012",
                    "grid-options": _vm.voyageGrid.gridOptions,
                    "column-defs": _vm.voyageGrid.columnDefs,
                    "row-data": _vm.voyageGrid.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.voyageGrid.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "template",
              { slot: "right" },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { height: "100%" },
                  attrs: {
                    no: "9",
                    "config-module": "150013",
                    "grid-options": _vm.voyageCostGrid.gridOptions,
                    "column-defs": _vm.voyageCostGrid.columnDefs,
                    "row-data": _vm.voyageCostGrid.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.voyageCostGrid.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }